module.exports = __webpack_public_path__ + "img/portrait-023.b5447231.jpg";